export default function guest ({ next, store }){
    if(store.getters.currentUser.loggedIn){
        return next({
           name: 'dashboard'
        })
    }

    return next()
}
